import api from '../lib/api';
import type { TimeCondition, TimeException } from '../types/timeCondition';

class TimeConditionService {
  async getTimeConditions(): Promise<TimeCondition[]> {
    const response = await api.get('/assistants/time-conditions');
    return Array.isArray(response.data) ? response.data : response.data?.data || [];
  }

  async getTimeCondition(id: number): Promise<TimeCondition> {
    const response = await api.get(`/assistants/time-conditions/${id}`);
    return response.data;
  }

  async createTimeCondition(data: Partial<TimeCondition>): Promise<TimeCondition> {
    const response = await api.post('/assistants/time-conditions', data);
    return response.data;
  }

  async updateTimeCondition(id: number, data: Partial<TimeCondition>): Promise<TimeCondition> {
    const response = await api.put(`/assistants/time-conditions/${id}`, data);
    return response.data;
  }

  async deleteTimeCondition(id: number): Promise<void> {
    await api.delete(`/assistants/time-conditions/${id}`);
  }

  // Exceptions API
  async getExceptions(): Promise<TimeException[]> {
    const response = await api.get('/assistants/time-exceptions');
    return response.data;
  }

  async getException(id: number): Promise<TimeException> {
    const response = await api.get(`/assistants/time-exceptions/${id}`);
    return response.data;
  }

  async createException(data: Partial<TimeException>): Promise<TimeException> {
    const response = await api.post('/assistants/time-exceptions', data);
    return response.data;
  }

  async updateException(id: number, data: Partial<TimeException>): Promise<TimeException> {
    const response = await api.put(`/assistants/time-exceptions/${id}`, data);
    return response.data;
  }

  async deleteException(id: number): Promise<void> {
    await api.delete(`/assistants/time-exceptions/${id}`);
  }
}

export default new TimeConditionService();
